import { Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CustomerProvider } from "./lib/auth";
import CustomerLayout from "./components/CustomerLayout";
import Home from "./pages/Home";
import RequestPooja from "./pages/RequestPooja";
import Priests from "./pages/Priests";
import Bookings from "./pages/Bookings";
import Profile from "./pages/Profile";
import PuroMitra from "./pages/PuroMitra";

function Soon({ title, sub }) {
  return (
    <div className="px-4 pt-10 text-center" data-testid="cust-soon">
      <h1 className="font-heading text-2xl text-[#2A211C]">{title}</h1>
      <p className="mt-2 text-sm text-[#7A6E64]">{sub}</p>
    </div>
  );
}

export default function CustomerApp() {
  return (
    <CustomerProvider>
      <Toaster position="top-center" richColors />
      <Routes>
        <Route element={<CustomerLayout />}>
          <Route index element={<Home />} />
          <Route path="request" element={<RequestPooja />} />
          <Route path="priests" element={<Priests />} />
          <Route path="bookings" element={<Bookings />} />
          <Route path="messages" element={<Soon title="Messages" sub="Chat with your purohit once a proposal is accepted." />} />
          <Route path="puromitra" element={<PuroMitra />} />
          <Route path="profile" element={<Profile />} />
        </Route>
      </Routes>
    </CustomerProvider>
  );
}
